import { AppError } from '@vk-hr-tek/ui/error';
import { Box } from '@vk-hr-tek/ui/Box';
import { Typography } from '@vk-hr-tek/ui/Typography';
import { CopyButton } from '@vk-hr-tek/ui/CopyButton';

/**
 * Свойства компонента {@link SubmitError}
 */
interface SubmitErrorProps {
  /**
   * Ошибка, возникшая при отправке формы.
   */
  submitError: AppError;

  /**
   * Флаг для отображения описания ошибки.
   *
   * @defaultValue `false`
   */
  withDescription?: boolean;
}

/**
 * Компонент для отображения ошибки при отправке формы.
 *
 * @public
 * @param submitError - Ошибка, возникшая при отправке формы.
 * @param withDescription - Флаг для отображения описания ошибки.
 * @returns Компонент для отображения ошибки.
 *
 * @remarks
 *
 * Ссылка на свойства компонента {@link SubmitErrorProps}
 */
export const SubmitError = ({
  submitError,
  withDescription,
}: SubmitErrorProps) => {
  return (
    <Box>
      <Typography color="accent.text.error" variant="body3">
        {submitError && submitError.title
          ? submitError.title
          : 'Что-то пошло не так. Напишите в чат поддержки и сообщите код ошибки'}
      </Typography>
      {withDescription && submitError.description && (
        <Typography color="accent.text.error" variant="body3">
          {submitError.description}
        </Typography>
      )}
      {submitError?.traceId && (
        <Box display="flex" alignItems="center" mt="8" gap="8">
          <Typography color="text.light.tertirary" variant="body3">
            {`Код ошибки: ${submitError.traceId}`}
          </Typography>
          <CopyButton valueToCopy={submitError.traceId} size="16" />
        </Box>
      )}
    </Box>
  );
};
